import React from 'react';

function GoogleIcon() {
    return (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.575 10.2249C19.575 9.56659 19.5167 8.94159 19.4167 8.33325H10V12.0916H15.3917C15.15 13.3249 14.4417 14.3666 13.3917 15.0749V17.5749H16.6083C18.4917 15.8333 19.575 13.2666 19.575 10.2249Z"
                fill="#4285F4"
            />
            <path
                d="M10.0002 20.0001C12.7002 20.0001 14.9585 19.1001 16.6085 17.5751L13.3919 15.0751C12.4919 15.6751 11.3502 16.0418 10.0002 16.0418C7.39186 16.0418 5.18353 14.2834 4.39186 11.9084H1.0752V14.4834C2.71686 17.7501 6.09186 20.0001 10.0002 20.0001Z"
                fill="#34A853"
            />
            <path
                d="M4.39167 11.9083C4.18333 11.3083 4.075 10.6666 4.075 9.99993C4.075 9.33327 4.19167 8.6916 4.39167 8.0916V5.5166H1.075C0.391666 6.8666 0 8.38327 0 9.99993C0 11.6166 0.391666 13.1333 1.075 14.4833L4.39167 11.9083Z"
                fill="#FBBC05"
            />
            <path
                d="M10.0002 3.95833C11.4752 3.95833 12.7919 4.46667 13.8335 5.45834L16.6835 2.60833C14.9585 0.991668 12.7002 0 10.0002 0C6.09186 0 2.71686 2.25 1.0752 5.51667L4.39186 8.09167C5.18353 5.71667 7.39186 3.95833 10.0002 3.95833Z"
                fill="#EA4335"
            />
        </svg>
    );
}

export default GoogleIcon;
